import AccountMenuView from './account-menu-view'

export default AccountMenuView
